import React from 'react';
import { Menu } from 'antd';
import { useNavigate } from 'react-router-dom';
import {
    HomeOutlined,
    AppstoreOutlined,
    TeamOutlined,
    TrophyOutlined,
    InboxOutlined,
    DollarOutlined,
    BarChartOutlined,
    UserOutlined,
    LogoutOutlined,
    PlusCircleOutlined,
    UnorderedListOutlined,
    FileTextOutlined,
    DatabaseOutlined
} from '@ant-design/icons';
import axiosClient from '../../api/axiosClient';

const Navbarmenu = () => {
    const navigate = useNavigate();

    const member_allow = false;
    const member_create = false;
    const member_list = false;

    const trainer_allow = false;
    const trainer_create = false;
    const trainer_list = false;

    const inventory_allow = false;
    const inventory_list = false;

    const report_allow = false;

    const logout = async () => {
        try {
            await axiosClient.post('/user/logout.php');
        } catch (error) {
            console.error("Logout failed", error);
        } finally {
            localStorage.clear();
            navigate('/login');
        }
    }

    return (
        <Menu mode='horizontal' selectable={true} style={{ minWidth: 0 }}>
            <Menu.SubMenu key={0} title="Menu" icon={<AppstoreOutlined style={{ color: '#209c96' }} />}>
                
                {/* Dashboard */}
                <Menu.Item key={1} onClick={() => navigate('/dash')} icon={<HomeOutlined />}>
                    Dashboard
                </Menu.Item>

                <Menu.Divider />

                {/* People Management */}
                <Menu.SubMenu disabled={member_allow} key={2} title="Members" icon={<TeamOutlined />}>
                    <Menu.Item disabled={member_create} key={2.1} onClick={() => navigate('/members/create')} icon={<PlusCircleOutlined />}>
                        Register Member
                    </Menu.Item>
                    <Menu.Item disabled={member_list} key={2.2} onClick={() => navigate('/members/view')} icon={<UnorderedListOutlined />}>
                        List Of Members
                    </Menu.Item>
                </Menu.SubMenu>

                <Menu.SubMenu disabled={trainer_allow} key={3} title="Trainers" icon={<TrophyOutlined />}>
                    <Menu.Item disabled={trainer_create} key={3.1} onClick={() => navigate('/trainers/create')} icon={<PlusCircleOutlined />}>
                        Register Trainer
                    </Menu.Item>
                    <Menu.Item disabled={trainer_list} key={3.2} onClick={() => navigate('/trainers/view')} icon={<UnorderedListOutlined />}>
                        List Of Trainers
                    </Menu.Item>
                </Menu.SubMenu>

                <Menu.Divider />

                {/* Operations */}
                <Menu.SubMenu disabled={inventory_allow} key={4} title="Inventory" icon={<InboxOutlined />}>
                    <Menu.Item disabled={inventory_list} key={4.1} onClick={() => navigate('/inventory/itemList')} icon={<UnorderedListOutlined />}>
                        Item List
                    </Menu.Item>
                    <Menu.Item disabled={inventory_list} key={4.2} onClick={() => navigate('/inventory/records')} icon={<FileTextOutlined />}>
                        Records
                    </Menu.Item>
                </Menu.SubMenu>

                <Menu.SubMenu key={5} title="Sales" icon={<DollarOutlined />}>
                    <Menu.Item key={5.1} onClick={() => navigate('/sales/items')} icon={<UnorderedListOutlined />}>
                        Sales Items
                    </Menu.Item>
                    <Menu.Item key={5.2} onClick={() => navigate('/sales/add')} icon={<PlusCircleOutlined />}>
                        Add Sales Item
                    </Menu.Item>
                </Menu.SubMenu>

                <Menu.SubMenu key={6} title="Invoices" icon={<FileTextOutlined />}>
                    <Menu.Item key={6.1} onClick={() => navigate('/invoices')} icon={<UnorderedListOutlined />}>
                        All Invoices
                    </Menu.Item>
                    <Menu.Item key={6.2} onClick={() => navigate('/invoices/create')} icon={<PlusCircleOutlined />}>
                        Create Invoice
                    </Menu.Item>
                </Menu.SubMenu>

                <Menu.Divider />

                {/* Master Data */}
                <Menu.SubMenu key={20} title="Master Data" icon={<DatabaseOutlined />}>
                    <Menu.Item key={20.1} onClick={() => navigate('/master/categories')} icon={<UnorderedListOutlined />}>
                        Inventory Categories
                    </Menu.Item>
                    <Menu.Item key={20.2} onClick={() => navigate('/master/types')} icon={<UnorderedListOutlined />}>
                        Inventory Types
                    </Menu.Item>
                </Menu.SubMenu>

                <Menu.Divider />

                {/* Analytics */}
                <Menu.Item disabled={false} key={11} onClick={() => navigate('/reports')} icon={<BarChartOutlined />}>
                    Reports & Analytics
                </Menu.Item>

                <Menu.Divider />

                {/* Account */}
                <Menu.SubMenu key={100} title="My Account" icon={<UserOutlined />}>
                    <Menu.Item key={100.2} onClick={() => logout()} icon={<LogoutOutlined />}>
                        Sign Out
                    </Menu.Item>
                </Menu.SubMenu>

            </Menu.SubMenu>
        </Menu>
    );
};

export default Navbarmenu;